import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import MobileCapture from "./MobileCapture";
import useTranslator from "../../hooks/useTranslator";
import "./mobileCapture.css";

const MobileCapturePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { _t } = useTranslator();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError(_t("mobileCaptureMissingToken"));
    }
  }, [token, _t]);

  if (!token) {
    return (
      <div className="mobile-capture-error-screen">
        <div className="mobile-capture-error-content">
          <h2>
            {error || _t("mobileCaptureInvalidLink")}
          </h2>
          <p>{_t("mobileCaptureInvalidLinkDesc")}</p>
        </div>
      </div>
    );
  }

  return <MobileCapture sessionToken={token} />;
};

export default MobileCapturePage;
